import React from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  Row,
  Col
} from 'react-bootstrap';
import Select from 'react-select';

const JNInitWizardPageFive = (props) => {
  const {
    handleTypeDefaultChange,
    handleStatusDefaultChange,
    workflows,
    type_default,
    status_default
  } = props;

  const filtered_workflows = workflows.filter(wf => wf.object_type == 'contact');
  const type_default_opts = filtered_workflows.map(wf => ({ value: wf.id, label: wf.name, clearableValue: false }));
  const current_type_default = filtered_workflows.find(t => type_default && t.id == type_default.value);
  const status_default_opts =
    current_type_default ?
    current_type_default.status.map(s => ({ value: s.id, label: s.name, clearableValue: false })) :
    [];

  return (
    <div className='jn-init-wizard-pg-five-container'>
      <h4>Choose a Contact Type and Status :</h4>
      <Panel>
        <p>
          Any new Job Nimbus contacts that are being created from your Hail Trace data{' '}
          will need to have the fields 'Contact Type' and 'Status', as they are required fields{' '}
          in Job Nimbus. Please choose values for the Contact Type and Status fields.
        </p>
        <hr className='dotted short' />

        <Row>
          <Col xs={12} md={12}>
            <Select
              clearable={false}
              options={type_default_opts}
              onChange={handleTypeDefaultChange}
              value={type_default}
              placeholder='Choose a Contact Type'
            />
          </Col>
        </Row>
        <Row className='mt-md'>
          <Col xs={12} md={12}>
            <Select
              clearable={false}
              disabled={current_type_default == null}
              options={status_default_opts}
              onChange={handleStatusDefaultChange}
              value={status_default}
              placeholder={current_type_default ? 'Choose a Status Name' : 'Must choose a Contact Type before choosing a status'}
            />
          </Col>
        </Row>
      </Panel>
    </div>
  );
}

export default JNInitWizardPageFive;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-init-wizard-pg-five.js